module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ok":"OK"},"zh-tw":{"ok":"確定"}}')
  delete Component.options._Ctor
}
